// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"766":"0251fd7e","831":"23046ddf"}[chunkId] + ".chunk.css";
};